import {api} from 'helpers/api';
import {success, error} from 'helpers/response';
import {Map} from "immutable";

const initialState = new Map({
});

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    }

    return state;
}

export const getGuestToken = () => async () => {
    try {
        const response = await api.auth.getGuestToken();

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/auth.js